import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import { ButtonDropdown, DropdownMenu, DropdownToggle, Label } from 'reactstrap'
import { CloseIcon, FilterIcon } from '../../../assets/images'
import { CalenderIcon } from '../../Icon';
import moment from 'moment';
import { handleDate, reverseDate } from '../../../utils/commonFunctions';
type AppProps = {
    applyFilter: (data: any) => void;
    clearFilter: () => void;
    targetStartDate: string;
    targetEndDate: string;
    setTargetStartDate: React.Dispatch<React.SetStateAction<string>>;
    setTargetEndDate: React.Dispatch<React.SetStateAction<string>>;
}
const NewRequestAndApprovalListFilter = ({
    applyFilter,
    targetStartDate,
    targetEndDate,
    setTargetStartDate,
    setTargetEndDate,
    clearFilter
}: AppProps) => {
    const [filterTargetStartDate, setFilterTargetStartDate] = useState("")
    const [filterTargetEndDate, setFilterTargetEndDate] = useState("")
    const [toggle, setToggle] = useState(false)
    const [filterCount, setFilterCount] = useState(0)

    const handleStartDateChange = (date: string) => {
        const value = handleDate(date)
        setFilterTargetStartDate(value)
        setTargetStartDate(value?reverseDate(value):"")
    }

    const handleEndDateChange = (date: string) => {
        const value = handleDate(date)
        setFilterTargetEndDate(value)
        setTargetEndDate(value?reverseDate(value):"")
    }

    const submitFilterData = () => {
        const finalData = {
            targetStartDate,
            targetEndDate
        }
        if(targetEndDate&&targetStartDate){
            setFilterCount(2)
        }
        else if(targetEndDate||targetStartDate){
            setFilterCount(1)
        }
        else{
            setFilterCount(0)
        }
        applyFilter(finalData)
    }
    return (
        <ButtonDropdown
            isOpen={toggle}
            toggle={() => {
                // filterCount === 0 && toggle ? resetFilter() : empty()
                setToggle(!toggle)
            }}

        >
            <DropdownToggle
                caret
                color='#262a44'
                style={{
                    border: "1px solid #bfcbe1",
                    backgroundColor: "#ffffff",
                    height: '38px'
                }}
            >
                <img src={FilterIcon} alt="" />
                {/* <img src={toggle?FilterIcon:filterBlackIcon } alt=""/> */}
                <span className={filterCount !== 0 ? 'filter-count' : ""}><span>{filterCount !== 0 ? filterCount : ""}</span></span>
            </DropdownToggle>
            <DropdownMenu right style={{ width: "400px", padding: '15px 25px 30px' }}>
                <div className='d-flex justify-content-between mt-0 mb-0'>
                    <h5 className='text-center '>Filter</h5>
                    <div className='pointer' onClick={() => {
                        setToggle(!toggle)
                        // setClearFilter(false)
                    }}>
                        <img src={CloseIcon} alt="" />
                    </div>

                </div>
                <hr className='mt-0 mb-2' />
                <span>Filter Data For Target End Date</span>
                <div className="row mt-3">
                    <div className='d-flex'>
                        <div className="form-group col-md-6">
                            <div className='date-picker-wraper mr-0 position-relative'>
                                <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}>From

                                    <DatePicker
                                        dateFormat="dd-MM-yyyy"
                                        selected={filterTargetStartDate ? new Date(moment(`${filterTargetStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                        onChange={(e: any) => { handleStartDateChange(moment(e).format('YYYY-MM-DD')) }}
                                        fixedHeight
                                        showMonthDropdown
                                        showYearDropdown
                                        name='filterTargetStartDate'
                                        placeholderText="Select"
                                        className='form-control'

                                    />
                                    <span className="calender-icon pr-3" style={{ top: "28px", right: '4px', cursor: 'pointer', position: "absolute" }}>
                                        <CalenderIcon />
                                    </span>
                                </Label>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <div className='date-picker-wraper mr-0'>
                                    <Label className='mb-1 p-0 w-100' style={{ fontSize: "14px" }}>To
                                        <DatePicker
                                            dateFormat="dd-MM-yyyy"
                                            selected={filterTargetEndDate ? new Date(moment(`${filterTargetEndDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                            onChange={(e: any) => { handleEndDateChange(moment(e).format('YYYY-MM-DD')) }}
                                            fixedHeight
                                            showMonthDropdown
                                            showYearDropdown
                                            name='filterTargetEndDate'
                                            placeholderText='Select'
                                            className='form-control'
                                            minDate={filterTargetStartDate ? new Date(moment(`${filterTargetStartDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                                        />
                                        <span className="calender-icon pr-3" style={{ top: "28px", right: '20px', cursor: 'pointer' }}>
                                            <CalenderIcon />
                                        </span>
                                    </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex align-items-center justify-content-end mt-3'>
                    <button className='mr-2 btn btn-outline' onClick={() => {
                        clearFilter()
                        setToggle(!toggle);
                        setFilterTargetStartDate("")
                        setFilterTargetEndDate("");
                        setFilterCount(0)
                    }
                    } disabled={filterTargetStartDate?.length||filterTargetEndDate?.length?false:true}>Clear Filter</button>
                    <button className='pl-4 pr-4 btn btn-primary' onClick={() => {
                        submitFilterData()
                        setToggle(!toggle)
                    }} disabled={filterTargetStartDate?.length||filterTargetEndDate?.length?false:true}>Apply</button>
                </div>

            </DropdownMenu>
        </ButtonDropdown>
    )
}

export default NewRequestAndApprovalListFilter